import { Injectable } from '@angular/core';
import { ModuleUserAccessLevel } from '../../../constants-types';
import { ModuleUser } from '../../../core-data-model';
import { IUserManagementService } from '../../../core-services/UserManagement/user-management.service';
import { EmailDomainValidatorDirective } from '../../../core-ui';
import { ModuleUserManagementComponent } from '../module-user-management-grid/module-user-management-grid.component';
import { ModuleUserManagementInvitationComponent } from '../module-user-management-invitation/module-user-management-invitation.component';

@Injectable()
export class ModuleUserManagementService implements IUserManagementService {
    moduleGrid: ModuleUserManagementComponent;
    moduleInvitation: ModuleUserManagementInvitationComponent;

    public allowedCompanyDomains: string[] = [];

    initData() {
        this.allowedCompanyDomains = this.getAllowedDomainForCompany();
    }

    // this will undergo changes as we implement a domain index per company.
    // right now will use the list from ModuleUserManagementComponent to retrieve domain
    // returns empty array if none
    getAllowedDomainForCompany(): string[] {
        if (
            !this.moduleGrid ||
            !this.moduleGrid.rowData ||
            this.moduleGrid.rowData.length == 0
        ) {
            return [];
        }
        // parse domains
        // return distinct
        return Array.from(
            new Set(
                this.moduleGrid.rowData
                    .filter((x) => x.accessLevel >= ModuleUserAccessLevel.Full)
                    .map((x) =>
                        EmailDomainValidatorDirective.extractDomain(x.email)
                    )
            )
        );
    }

    getExistingUsers(): ModuleUser[] {
        if (this.moduleGrid) {
            return this.moduleGrid.rowData;
        }
        return [];
    }
}
